export const DEFAULT_COLOR = '#0b6bf2';
export const SELECTED_COLOR = '#00c40a';
